<nav id={{id}}>
  <header>
    {{#if current_route}}
    <button class="icon-btn menu-item-icon nav-backward" type="button" aria-label="{{t 'courseMenu.navigateBackward'}}"
      title="{{t 'courseMenu.navigateBackward'}}">
      <span>
        {{>icon uuid=cid icon="fal fa-chevron-left" }}
      </span>
    </button>
    {{/if}}
    <span role="menuheader" tabindex="-1">
      {{t current_header}}
    </span>
    <button class="menu-close-btn icon-btn" type="button" aria-label="{{t 'courseMenu.closeMenu'}}"
      title="{{t 'courseMenu.closeMenu'}}">
      <span>
        {{>icon uuid=cid icon="fal fa-times" size="fa-lg"}}
      </span>
    </button>

  </header>
  <ul class="menu" role="menu" aria-labelledby="menubutton-menu-{{id}}">
    {{#each current_items}}
    <li role="none" data-index="{{@index}}" tabindex="-1">
      {{#if content}}
      <a role="menuitem" tabindex="0" aria-haspopup="true" class="icon-btn">
        <span>
          {{#if title}}{{t title}}{{else}}{{key}}{{/if}}
        </span>
        <span class="menu-item-icon" aria-hidden="true">
          {{>icon uuid=../cid index=@index icon="fas fa-caret-right" }}
        </span>
      </a>
      {{else}}
      <a role="menuitem" class="item-link {{#if active}} active
      {{else if completed}}
        completed
      {{else}}
        incomplete
      {{/if}}" href="{{path}}" tabindex="0">
        <span>
          {{#if title}}{{t title}}{{else}}{{key}}{{/if}}
        </span>
        <span class="menu-item-icon" aria-hidden="true">
          {{#if active}}
            {{>icon uuid=../cid index=@index icon="fas fa-circle" }}
          {{else if completed}}
            {{>icon uuid=../cid index=@index icon="fas fa-check-circle" }}
          {{else}}
            {{>icon uuid=../cid index=@index icon="fas fa-lock" }}
          {{/if}}
        </span>
      </a>
      {{/if}}
    </li>
    {{/each}}
  </ul>
</nav>
